import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { RackCrudService } from 'src/app/shared/services/rack-crud.service';
import { Rack } from 'src/app/shared/interfaces/rack';
import { RackLocationCrudService } from 'src/app/shared/services/rack-location-crud.service';
import { RackLocation } from 'src/app/shared/interfaces/rack-location';
import { Barrel } from 'src/app/shared/interfaces/barrel';
import { BarrelCrudService } from 'src/app/shared/services/barrel-crud.service';

@Component({
  selector: 'app-racks',
  templateUrl: './racks.component.html',
  styleUrls: ['./racks.component.scss']
})
export class RacksComponent implements OnInit {

  racks: Rack[];
  rack: Rack;
  selectedRacks: Rack[] = [];
  racksMap : Map<string,Rack>;

  rackDialog: boolean = false;

  submitted: boolean = false;

  baysNb: number[];
  columnsNb: number[];
  levelsNb: number[];

  locations: RackLocation[];
  locationsMap : Map<string,RackLocation>;

  barrels: Barrel[];
  barrelsMap : Map<string,Barrel>;
  originalBarrels: Barrel[];
  originalBarrelsMap : Map<string,Barrel>;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private rackService : RackCrudService,
    private rackLocationService : RackLocationCrudService,
    private barrelService : BarrelCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Racks'}
    ];

    this.racks = [];
    this.rack = { } as Rack ;
    this.racksMap = new Map<string,Rack>();

    this.baysNb = [];
    this.columnsNb = [];
    this.levelsNb = [];

    this.locations = [];
    this.locationsMap = new Map<string,RackLocation>();

    this.barrels = [];
    this.barrelsMap = new Map<string,Barrel>();

    this.originalBarrels = [];
    this.originalBarrelsMap = new Map<string,Barrel>();

  }

  ngOnInit(): void {

    this.isFilter = false;

    for(let i = 1; i < 28; i++ ) {
      this.baysNb.push(i);
    }
    for(let i = 1; i < 6; i++ ) {
      this.columnsNb.push(i);
    }
    for(let i = 1; i < 6; i++ ) {
      this.levelsNb.push(i);
    }
    
    this.dataState();
    let s = this.rackService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.racks = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Rack = jsonItem as Rack;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.racks.push(l);
          this.racksMap.set( l.$key , l);
        }
      })
    });

    let loc = this.rackLocationService.getLocationsList(); 
    loc.snapshotChanges().subscribe(data => {
      this.locations = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : RackLocation = jsonItem as RackLocation;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.locations.push(l);
          this.locationsMap.set( l.$key , l);
        }
      })
    });

    let b = this.barrelService.getList(); 
    b.snapshotChanges().subscribe(data => {
      this.barrels = [];
      this.originalBarrels = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Barrel = jsonItem as Barrel;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.barrels.push(l);
          this.barrelsMap.set( l.$key , l);
          this.originalBarrels.push(l);
          this.originalBarrelsMap.set( l.$key , l);
        }
      })
      // this.originalBarrels = Object.assign([],this.barrels);
      // this.originalBarrelsMap = Object.assign({}, this.barrelsMap);
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'locationName', header: 'Location' },
      { field: 'isInBay', header: 'isInBay' },
      { field: 'bayNumber', header: 'Bay' },
      { field: 'columnNumber', header: 'Column' },
      { field: 'levelNumber', header: 'Level' },
      { field: 'barrels', header: 'Barrels' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.rackService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.racks);
            doc.save('racks.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.racks);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "racks");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedRacks);
      // console.log('SAVEC CSV LOCATIONS ', this.racks);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedRacks, 'racks', exportCols);
   // this.exportService.exportToCsv(this.racks, 'racks', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.rack = {} as Rack;
    this.submitted = false;
    this.rackDialog = true;
  }

  deleteSelectedRacks() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected racks?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.racks = this.racks.filter(val => !this.selectedRacks.includes(val));
            
            this.selectedRacks.forEach( rack => this.rackService.delete(rack.$key));
            this.selectedRacks = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Rackss Deleted', life: 3000});
        }
    });
  }

  editRack(rack: Rack) {
    this.rack = {...rack};
    this.rackDialog = true;
  }

  deleteRack(rack: Rack) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + rack.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.racks = this.racks.filter(val => val.$key !== rack.$key);
            this.rack = {} as Rack;
            this.rackService.delete(rack.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Rack Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.rackDialog = false;
    this.submitted = false;
  }

  saveRack() {
    this.submitted = true;

    if ( this.rack.name.trim() ) {
      if (this.rack.$key) {
          this.racks[this.findIndexById(this.rack.$key)] = this.rack;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Rack Updated', life: 3000});
          this.rackService.update(this.rack);
        } else {
          this.rack.position = this.racks.length;
          this.rackService.add(this.rack);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Rack Created', life: 3000});
      this.racks = [...this.racks];
    }

    this.rackDialog = false;
    this.rack = { } as Rack;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.racks.length; i++) {
        if (this.racks[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeRack(rack : Rack) {
    //console.log("SAVE", rack);
    this.rackService.update(rack);
  }
  

  completePosition(rack : Rack) {
   // console.log("SAVE", rack);
  //  this.rackService.updateRack(rack);


    if ( this.newPosition > -1 ) {
        rack.position = this.newPosition;
        rack = this.checkPositionLimits(rack);
        this.reorderElements(rack);
        //this.updateDB(rack);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.racks);
    // const myClonedArray = [];
    // this.racks.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.racks.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.racks.length - 1 - event.dropIndex;
    const rackToMove = this.racks[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.racks[index] = this.racks[index+1];
        this.racks[index].position = index;
        this.rackService.update(this.racks[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.racks[index] = this.racks[index-1];
        this.racks[index].position = index;
        this.rackService.update(this.racks[index]);
      }
    } 
    this.racks[endIndex] = rackToMove;
    this.racks[endIndex].position = endIndex;
    this.rackService.update(this.racks[endIndex]);
  }

  // onFieldEdit(rack: Spray, fieldName: string): void {
  //   //console.log(this.racks);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + rack[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       rack.position = this.newPosition;
  //       rack = this.checkPositionLimits(rack);
  //       this.reorderElements(rack);
  //       //this.updateDB(rack);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(rack);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.racks.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, rack: Rack) {
    // console.log("event" +event);
    if (rack.position != null && rack.position > -1) {
      this.previousPosition = rack.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(rack: Rack) {
    console.log('check ',rack.position + ' ' + this.racks.length);
    if (!rack.position) {
     // console.log('check 1');
      return this.rack;
    }
    if (rack.position < 0) {
      rack.position = 0;
      // console.log('check 2');
      return rack;
    }
    if (rack.position > this.racks.length) {
      rack.position = this.racks.length - 1;
    //  console.log('check 3', rack.position);
      return rack;
    }
   // console.log('check 4');
    return rack;
  }

  async reorderElements(rack: Rack) {
    this.newPosition = this.newPosition  > this.racks.length ? this.racks.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === rack.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const rackToMove = this.racks[startIndex];
   // console.log('Item to move: ', this.racks[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.racks);
        console.log('Item to +1: ', this.racks[index+1]);

        this.racks[index] = this.racks[index+1];
        this.racks[index].position = index;
        // console.log('Move: ', this.racks[index+1]);
        // console.log('Move pos: ', this.racks[index].position);
        //await this.updateDB(this.racks[index]);
        this.rackService.update(this.racks[index]);
     //   console.log('Update DB: ', this.racks[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.racks[index] = this.racks[index-1];
        this.racks[index].position = index;
        this.rackService.update(this.racks[index]);
      }
    } 
    this.racks[endIndex] = rackToMove;
    this.racks[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.rackService.update(this.racks[endIndex]);
    
    // const myClonedArray = [];
    // this.racks.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.racks = myClonedArray;
   // this.getAllRecords();
  }

  getRackImage(rack: Rack) : string {
    if (!rack.barrel1Name && !rack.barrel2Name) {
      return 'empty';
    }
    if (rack.barrel1Name && rack.barrel2Name) {
      return 'full';
    }
    if (rack.barrel1Name) {
      return 'left';
    }
    return 'right';
  }

  displayBarrelName(key : string) {
    const barrel = this.barrelsMap.get(key);
    return barrel?.name;
  }

  completeRackLocation(rack : Rack, barrelKey: string) {
    //console.log("SAVE", rack);
    

    console.log( 'Barrel 1 Key ', rack.barrel1Key );

    const barrel = this.barrelsMap.get( rack.barrel1Key || '' );
    // if ( barrel?.rackKey )  {

    // }
    
    console.log(  'barrel', barrel);

    //this.rackService.update(rack);
  }

  checkValue1(rack: Rack, barrelKey: string, event: any): boolean {

    //console.log('be ', event);

    const newBarrelKey = event.value;
    const previousBarrelKey = barrelKey;
    console.log('new key wanted',  newBarrelKey);
    console.log('before key ', previousBarrelKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousBarrelKey && !newBarrelKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousBarrelKey && newBarrelKey && previousBarrelKey == newBarrelKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousBarrelKey && newBarrelKey) {

      const newBarrel = this.barrelsMap.get(newBarrelKey) || {} as Barrel;
      const newBarrelName = newBarrel.name;
        
      rack.barrel1Key = newBarrelKey;
      rack.barrel1Name = newBarrelName;
      this.rackService.update(rack);
      return true;

    }

    if (previousBarrelKey && !newBarrelKey) {
      rack.barrel1Key = '';
      rack.barrel1Name = '';
      this.rackService.update(rack);
      return true;
    }

    const newBarrel = this.barrelsMap.get(newBarrelKey) || {} as Barrel;
    const newBarrelName = newBarrel.name;
    rack.barrel1Key = newBarrelKey;
    rack.barrel1Name = newBarrelName;
    this.rackService.update(rack);
    return true;
       

    // Si il n'y avait pas de barril avant dans ce rack
    // if (!barrelKey) {

    //   const newBarrel = this.barrelsMap.get(newBarrelKey) || {} as Barrel;
    //   this.barrelService.update(newBarrel);

    //   rack.barrel1Key = newBarrelKey;
    //   this.rackService.update(rack);
    //   return true;
    // }

    // SI il y avait un barril avant alors
    // il faut le retirer et dire que ce barril n'est pls la
    // const previousBarrel : Barrel = this.barrelsMap.get(barrelKey) || {} as Barrel;
    // if (previousBarrel) {
    //   previousBarrel.rackKey = '';
    //   this.barrelService.update(previousBarrel);
    // }

    // const newBarrel = this.barrelsMap.get(newBarrelKey) || {} as Barrel;
    // this.barrelService.update(newBarrel);

    // return true;



    // The previous barrel is not anymore on this rack
    // SO we need to say it to the barrel
    

    // const obarrel = this.originalBarrelsMap.get(value);
    // console.log('bo ', obarrel);



    // const barrel = this.barrelsMap.get(value);
    // console.log('b ', barrel);

    const newValue = event.value;
    //const oldValue = this.selectedCity;
  
    // Perform check on the new value here
    if (newValue === 'LDN') {
      console.log('Value cannot be updated to London!');
      return false;
    }
  
    return true;
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   const myArrayChange = changes['barrels'];

  //   if (myArrayChange) {
  //     const myObjectIndex = this.barrels;

  //     console.log(myArrayChange);

  //   //   if (myObjectIndex > -1 && myArrayChange.currentValue[myObjectIndex].myField === 'someValue') {
  //   //     // Execute specific action here
  //   //     console.log('Performing specific action before setting value');

  //   //     // Update the field value
  //   //     this.myArray[myObjectIndex].myField = 'newValue';
  //   //   }
  //   }
  // }


  checkValue2(rack: Rack, barrelKey: string, event: any): boolean {

    //console.log('be ', event);

    const newBarrelKey = event.value;
    const previousBarrelKey = barrelKey;
    // console.log('new key wanted',  newBarrelKey);
    // console.log('before key ', previousBarrelKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousBarrelKey && !newBarrelKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousBarrelKey && newBarrelKey && previousBarrelKey == newBarrelKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousBarrelKey && newBarrelKey) {

      const newBarrel = this.barrelsMap.get(newBarrelKey) || {} as Barrel;
      const newBarrelName = newBarrel.name;
        
      rack.barrel2Key = newBarrelKey;
      rack.barrel2Name = newBarrelName;
      this.rackService.update(rack);
      return true;

    }

    if (previousBarrelKey && !newBarrelKey) {
      rack.barrel2Key = '';
      rack.barrel2Name = '';
      this.rackService.update(rack);
      return true;
    }

    const newBarrel = this.barrelsMap.get(newBarrelKey) || {} as Barrel;
    const newBarrelName = newBarrel.name;
    rack.barrel2Key = newBarrelKey;
    rack.barrel2Name = newBarrelName;
    this.rackService.update(rack);
    return true;
  }

  onChangeBayNb(rack: Rack, rackBayNbKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = rackBayNbKey;
    console.log('new key wanted',  newKey);
    console.log('before key ', previousKey);

    if (!newKey) {
      rack.bayNumber = 0;
    }
    this.rackService.update(rack);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    // if (!previousKey && !newKey) {
    //   return true;
    // }

    // // Si le barril est le meme rien a faire
    // if (previousKey && newKey && previousKey == newKey) {
    //   return true;
    // }


    // // Sil il n'y avait pas de barril avant et maintenant oui
    // if (!previousKey && newKey) {

    //   const newCooper = this.coopersMap.get(newKey) || {} as Cooper;
    //   const newCooperName = newCooper.name;
        
    //   barrel.cooperKey = newKey;
    //   barrel.cooperName = newCooperName;
    //   this.barrelService.update(barrel);
    //   return true;

    // }

    // if (previousKey && !newKey) {
    //   barrel.cooperKey = '';
    //   barrel.cooperName = '';
    //   this.barrelService.update(barrel);
    //   return true;
    // }

    // const newCooper = this.coopersMap.get(newKey) || {} as Cooper;
    // const newCooperName = newCooper.name;
        
    // barrel.cooperKey = newKey;
    // barrel.cooperName = newCooperName;
    // this.barrelService.update(barrel);
    return true;
  }
}
